import {MapControl, MapControlProps, withLeaflet} from 'react-leaflet';
import L from "leaflet";

interface CutModeButtonProps extends MapControlProps {
    toggleCutMode: Function,
    cutModeEnabled: boolean,
    cutModeActive: boolean
}

class CutModeButton extends MapControl<CutModeButtonProps, L.Control.EasyButton> {

    createLeafletElement(props: CutModeButtonProps): L.Control.EasyButton {
        return new L.Control.EasyButton({
            id: 'toggleCutModeBtn',
            states: [
                {
                    stateName: 'disabled',
                    icon: 'fas fa-cut disabled',
                    title: 'Kan ikke klippe når annen modus er valgt',
                    onClick: () => {
                        this.props.toggleCutMode();
                    }
                },
                {
                    stateName: 'inactive',
                    icon: 'fas fa-cut inactive',
                    title: 'Klikk for å aktivere klipping av objekter',
                    onClick: () => {
                        this.props.toggleCutMode();
                    }
                },
                {
                    stateName: 'active',
                    icon: 'fas fa-cut active',
                    title: 'Klikk for å skru av klipping av objekter',
                    onClick: () => {
                        this.props.toggleCutMode();
                    }
                }
            ]
        });
    }

    componentDidUpdate () {
        if (!this.props.cutModeEnabled) {
            this.leafletElement.state("disabled")
        } else if (this.props.cutModeActive) {
            this.leafletElement.state("active")
        } else {
            this.leafletElement.state("inactive")
        }
    }
}

export default withLeaflet(CutModeButton);
